import { reqGet, reqPut, reqDelete, reqPost } from './axiosFun';

// login
export const authLogin = (params) => { return reqPost("/auth/login", params) };

// logout
export const authLogout = (params) => { return reqPost("/auth/logout", params) };



// WEBPACK FOOTER //
// ./src/api/Auth.js